var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSvg = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.2rem",
    height: "1.2rem",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "1.2rem",
    height: "1.2rem",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5H12C11.7348 11.5 11.4804 11.3946 11.2929 11.2071C11.1054 11.0196 11 10.7652 11 10.5V5.5C11 5.23478 11.1054 4.98043 11.2929 4.79289C11.4804 4.60536 11.7348 4.5 12 4.5H15V5.5H12V10.5H14V8.5H13V7.5H15V11.5Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5L8 11L7 4.5H6L7.26 11.5H8.74L10 4.5H9Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5H1V10.5H4V8.5H2C1.73478 8.5 1.48043 8.39464 1.29289 8.20711C1.10536 8.01957 1 7.76522 1 7.5V5.5C1 5.23478 1.10536 4.98043 1.29289 4.79289C1.48043 4.60536 1.73478 4.5 2 4.5H5V5.5H2V7.5H4C4.26522 7.5 4.51957 7.60536 4.70711 7.79289C4.89464 7.98043 5 8.23478 5 8.5V10.5C5 10.7652 4.89464 11.0196 4.70711 11.2071C4.51957 11.3946 4.26522 11.5 4 11.5Z",
    fill: "#161616"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSvg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Svg.dc9ca932.svg";
export { ForwardRef as ReactComponent };